var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("header-sales"),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fv ct",
          staticStyle: { width: "100vw", height: "90vh" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.showItemsPromo,
                expression: "!showItemsPromo"
              }
            ],
            staticClass: "fv lc",
            staticStyle: { width: "700px", height: "50px" }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fv lc",
              staticStyle: { width: "700px", "margin-top": "15px" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "fh cc",
                  staticStyle: {
                    "font-size": "10px",
                    color: "#5c666f",
                    "margin-left": "243px"
                  }
                },
                [_vm._v("\n              Seleccione Moneda: \n          ")]
              ),
              _vm._v(" "),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.idMoneda,
                      expression: "idMoneda"
                    },
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showMoneda,
                      expression: "showMoneda"
                    }
                  ],
                  staticStyle: {
                    width: "212px",
                    height: "30px",
                    "padding-left": "5px",
                    "margin-left": "232px",
                    "border-radius": "5px",
                    "border-style": "solid",
                    border: "1px solid #dddddd",
                    "border-width": "1px"
                  },
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.idMoneda = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                _vm._l(_vm.moneda, function(option) {
                  return _c("option", { domProps: { value: option.id } }, [
                    _vm._v(_vm._s(option.nombre))
                  ])
                })
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "fv ct",
              staticStyle: {
                width: "710px",
                height: "65%",
                "margin-top": "15px",
                overflow: "auto"
              }
            },
            [
              _c(
                "div",
                { staticClass: "fh lc", staticStyle: { width: "700px" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "oblea-NuevoPedido",
                      on: { click: _vm.btnNuevoPedido }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "30px", height: "30px" },
                        attrs: { id: "icon-add", src: "/dist/icon-add.png" }
                      }),
                      _vm._v(" "),
                      _c("p", { attrs: { id: "label-realizarPedido" } }, [
                        _vm._v(_vm._s(_vm.laberPedido))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "oblea-NuevoPedido",
                      on: { click: _vm.btnEstadoPedido }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "30px", height: "30px" },
                        attrs: { id: "icon-add", src: "/dist/icon-pedidos.png" }
                      }),
                      _vm._v(" "),
                      _c("p", { attrs: { id: "label-realizarPedido" } }, [
                        _vm._v("Estado de Pedidos")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "oblea-NuevoPedido",
                      on: { click: _vm.btnCuentaCorriente }
                    },
                    [
                      _c("img", {
                        staticStyle: { width: "30px", height: "30px" },
                        attrs: { id: "icon-add", src: "/dist/icon-cc.png" }
                      }),
                      _vm._v(" "),
                      _c("p", { attrs: { id: "label-realizarPedido" } }, [
                        _vm._v("Cuenta Corriente")
                      ])
                    ]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showItemsPromo,
                      expression: "showItemsPromo"
                    }
                  ],
                  staticClass: "fh lc",
                  staticStyle: { width: "700px", "margin-top": "20px" }
                },
                [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showItemsPromo,
                          expression: "showItemsPromo"
                        }
                      ],
                      staticClass: "fh lc",
                      staticStyle: {
                        "margin-left": "12px",
                        "font-size": "15px",
                        color: "#5c666f",
                        "font-weight": "500"
                      }
                    },
                    [_vm._v("\n                  Promociones\n              ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showItemsPromo,
                          expression: "showItemsPromo"
                        }
                      ],
                      staticClass: "fh lb",
                      staticStyle: {
                        "font-size": "12px",
                        color: "#4969B2",
                        "font-weight": "600",
                        "margin-left": "8px"
                      },
                      attrs: { id: "verTodas" },
                      on: { click: _vm.verPromociones }
                    },
                    [_vm._v("\n                  Ver Todas\n              ")]
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showItemsPromo,
                      expression: "showItemsPromo"
                    }
                  ],
                  staticClass: "fh lc",
                  staticStyle: {
                    width: "700px",
                    height: "130px",
                    "margin-top": "5px"
                  }
                },
                _vm._l(_vm.itemsPromo, function(item) {
                  return _c("item-promocion", { attrs: { item: item } })
                })
              )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "fv cc",
        staticStyle: {
          width: "100%",
          height: "37%",
          background: "linear-gradient(#005a9f, #1899d6)"
        }
      },
      [
        _c("img", {
          staticStyle: { height: "150px" },
          attrs: { src: "/dist/logo-header.png" }
        })
      ]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3dd6f9e4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3dd6f9e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/home.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3dd6f9e4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/home/home.vue
// module chunks = 0